module.exports = __webpack_public_path__ + "static/media/11.5a728a8a.jpg";